import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Api from '@/lib/api/api';
var FETCH_LINKS_KEY = 'fetch_links';
/**
 * Create a custom filter predicate for the collection which returns the
 * models which match the ids passed.
 * @param Array array of ids
 */
function create_filter(ids) {
    return function(model) {
        return (ids.indexOf(model.id) > -1);
    };
}
/**
 * Take an API response and get a list of the ids which were returned
 * in the response.
 */
function get_returned_ids(resp) {
    var ids = [];
    if (resp && resp.data) {
        resp.data.forEach(function(item){
            ids.push(item.id);
        });
    }
    return _.compact(ids);
}
/**
 * Return a fetch function for fetching the collection again
 * using the 'next' link
 */
function generate_fetch_links(collection, resp) {
    if (!(resp && resp.links)) {
        return null;
    }

    // Build an object full of functions which will call variations
    // of collection.fetch based on the url of the link. eg
    // {
    //     'next': function() { collection.fetch({ url: resp.links.next })),
    //     'prev': function() { collection.fetch({ url: resp.links.prev })),
    //     etc.
    // }
    var fetch_links = {};
    Object.keys(resp.links).forEach(function(key){
        function generated_fetch(options) {
            options = _.extend({
                url: resp.links[key]
            }, options);
            return collection.fetch(options);
        }
        fetch_links[key] = _.bind(generated_fetch, collection);
    });
    return fetch_links;
}
var v5_Collection = Backbone.Collection.extend({
    parse: Api.parse_collection,
    sync: Api.sync,

    // Fetch nearly identical to Backbone.Collection.fetch
    // except it adds a 'filter' to the options returned
    // providing a function which can be used to filter
    // the collection and find the Models which were
    // returned with the query. Useful for pagination
    // and other stuff.
    fetch: function(options) {
        // Don't remove items from the collection by default.
        // We fetch the collection with many different filters.
        // We don't want stuff to go away just because we wanted
        // a subset of models from the API.
        options = _.extend({ remove: false }, options);
        var success = options.success;
        options.success = function(collection, resp, options) {
            var ids = get_returned_ids(resp);
            options.filter = create_filter(ids);
            options[FETCH_LINKS_KEY] = generate_fetch_links(collection, resp);
            if (success) {
                try {
                    return success(collection, resp, options);
                } catch (e) {
                    if (e.message === 'Callback was already called.'){
                        null;
                    } else {
                        console.warn(e);
                    }
                }
            }
        };
        return Backbone.Collection.prototype.fetch.call(this, options);
    },
    /**
     * Call fetch_all like you would fetch, but use it in
     * a promise context, so
     *      coll.fetch_all().then(function() { /* do something * /)
     */
    fetch_all: function(options) {
        options = _.extend({ remove: false }, options);
        if (!(options.data && options.data['page[size]'])) {
            options.data = options.data || {};
            options.data['page[size]'] = 100;
        }
        var final_data = [];
        var coll = this;
        return new Promise(function(resolve, reject) {
            function fetch_some_more(data, status, xhr) {
                if (data.data && _.isArray(data.data)) {
                    final_data = final_data.concat(data.data);
                }
                var next;
                try {
                    next = xhr.responseJSON.links.next;
                } catch (e) {
                    if (e.name != 'TypeError') throw e;
                }
                if (next) {
                    options.url = next;
                    // Clear out any data/query params we were passing in;
                    // The API's 'next' link supplies us with everything we need
                    options.data = {};
                    return coll.fetch(options).done(fetch_some_more);
                } else {
                    return resolve(final_data);
                }
            }
            coll.fetch(options).then(fetch_some_more, reject);
        });
    },
    /**
     * Lookup function lets you get a promise for looking up a
     * model. The arguments for done are the same as the
     * success: (model, response, options)
     *
     * Stolen from http://tech.adroll.com/blog/web/2013/11/12/lazyloading-backbone-collection-with-promises.html
     */
    lookup: function(id) {
        var deferred = $.Deferred();
        var model = this.get(id);
        function done() {
            deferred.resolve(model);
        }
        function fail() {
            this.remove({id: id});
            deferred.reject.apply(this, arguments);
        }
        if (model && model.is_loaded()) {
            deferred.resolve(model);
        } else {
            model = this.add({id: id});
            model.fetch()
                .done(done)
                .fail(fail.bind(this))
            ;
        }
        // Returning a Promise so that only this function can modify
        // the Deferred object
        return deferred.promise();
    },
    searching: {},
    // If someone can help me figure out how to clear the "searching" object at a proper time,
    // that'd be greeeeaaaat
    async_lookup: function(id) {
        var model = this.get(id);
        var self = this;

        // If the model is being searched for right now
        if (model && this.searching[model.id]) {
            // Add this promise to the nebulous # of other promises waiting for resolution
            return new Promise(function(resolve, reject){
                return self.searching[model.id].then(resolve);
            });
        // If the model has been searched for before, or is in the collection wholesale
        } else if (model && model.is_loaded()) {
            // If it has already been found some other time
            return Promise.resolve(model);
        } else {
            // If the model hasn't been searched before and isn't in the collection
            // Start a search, and allow other requests to attach to its promise chain
            this.searching[id] = new Promise(function(resolve, reject){
                model = self.add({id: id});
                model.fetch({
                    success: function(model){
                        resolve(model);
                    },
                    error: reject
                });
            });
            return this.searching[id];
        }
    },
});
export default v5_Collection;

